<app-modal>
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.details.documentsPage.path-modal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body *ngIf="!isLoading; else loadingAnimation">
        <div class="form-group row" *ngIf="hasRootPath; else noItems">
            <div class="col s12">
                <div class="app-file-manager">
                    <label for="tree" [ngClass]="labelClass">{{ label }}</label>
                    <p-tree id="tree"
                            [(value)]="items"
                            selectionMode="checkbox"
                            [metaKeySelection]="false"
                            [(selection)]="selectedNodes">
                    </p-tree>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    (click)="close()">Cancel
        </app-button>
        <app-button type="warning" *ngIf="items.length > 0 && !isLoading" (click)="updatePath()">
            {{ 'admin.tools.details.documentsPage.path-modal.buttons.update'| translate }}
        </app-button>
    </div>
</app-modal>

<ng-template #noItems>
    <div class="noItems">{{ 'admin.tools.details.documentsPage.path-modal.noItems'| translate }}</div>
</ng-template>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>





